<template>
  <div class="contentModal">
    <div v-show="$store.state.formPage ==0">
      <div class="cardProcessRrim" >
        <div class="title">
          <h3>Informações Gerais</h3>
        </div>
        <InformacaoGerais
          :configInputs="configInputs"
          @OBJ_Infor_Geral="getObjInforGeral"
          @mapMoldSap="getCavityMolde"
          @mold-found="setMoldFound"
        />
      </div>
      <div class="cardProcessRrim">
        <Produtos
          :configInputs="configInputs"
          @sendListaDeProdutos="getListPro"
        />
      </div>
    </div>

    <div class="cardProcessRrim" v-show="$store.state.formPage ==1">
      <div class="title">
        <h3>Informações sobre o Molde Fechado</h3>
      </div>
      <MoldeFechado
        :configInputs="configInputs"
        @dataMoldeFechado="getdataMoldeFechado"
        @dataCamara="dataCamara"
      />
      
    </div>

    <div class="cardProcessRrim" v-show="$store.state.formPage == 2">
      <div class="title">
      <h3>
        Check-List da Engenharia e Ferramentaria
      </h3>
      </div>
          <ChecklistSlot :configInputs="configInputs" @setDataCheckli3st="getDataChecklist" />
    </div>

    <div class="cardProcessRrim" v-show="$store.state.formPage == 3">
      <div class="title" style="margin-bottom: 0.4rem;">
        <h3>Informações do Molde Aberto</h3>
      </div>
      <MoldeAberto
        :configInputs="configInputs"
        @dataMoldeAberto="getDataMoldeAberto"
        :Cavity="Cavity"
        :molde="this.Molde"
        :checkedCamara="camara"
        :moldValid="validMold"
      />
    </div>
  </div>
</template>

<script>
import InformacaoGerais from "./Modules/Informacao-Gerais.vue";
import MoldeAberto from "./Modules/Molde-Aberto.vue";
import MoldeFechado from "./Modules/Molde-Fechado.vue";
import Produtos from "./Modules/Produtos.vue";
import button1 from "../../../../Button/Button_variants.vue";
import ChecklistSlot from "../../../../Tables/ChecklistSlot.vue";

export default {
  components: { InformacaoGerais, MoldeAberto, MoldeFechado, Produtos, button1, ChecklistSlot },
  data() {
    return {
      t: "",
      Cavity: Number,
      Molde: String,
      camara: false,
      teste: false,
      Molde: "",
      validMold: false,
      Sol: {}
    };
  },
  props: {
    configInputs: Number,
  },
  methods: {
    setMoldFound(valid) {
      this.validMold = valid
    },
    dataCamara(e){
      this.camara = e
    },
    getObjInforGeral(Obj) {
      this.Molde = Obj.MOLDE || ""; 
      this.$emit("setObjOfInforGeral", Obj);
    },
    getCavityMolde(cavity){
      this.Cavity = cavity
    },
    getListPro(List) {
      this.$emit("setListPro", List);
    },

    getdataMoldeFechado(Obj) {
      this.$emit("setObjMoldeFechado", Obj);
    },

    getDataMoldeAberto(Obj) {
      this.$emit("setObjMoldeAberto", Obj);
    },
    incrementPage() {
      this.$store.commit('increment');
    }
  },
};
</script>

<style scoped>

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

::placeholder {
    font-weight: 400;
    color: red!important;
}
.contentModal {
  height: 100%;
  transition: 0.5s;
  animation: fadeIn 0.3s ease forwards!important;
}

.contentModal .cardProcessRrim {
  opacity: 0;
  padding: 0rem 2rem;
  width: 100%;
  position: relative;
  padding: 0rem 2.5rem 0.8rem 2.5rem;
  background-color: var(--white);
  border-radius: 0.4rem;
  animation: fadeIn 1s ease forwards!important;
}

.contentModal .cardProcessRrim .title {
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--font_color);
  padding-bottom: 0.5rem;
}

h3 {
  font-size: 0.85rem;
  font-weight: 600;
  font-family: "Poppins", sans-serif;
}

@media (max-width: 425px) {
  .contentModal {
    padding: 20px 20px 0px 20px;
  }

  .contentModal .cardProcessRrim .title {
    font-size: 1rem;
  }
}
</style>
